import React, { useEffect, useState } from "react";
import { SelectDevices } from "./SelectDevices";
import { getBasicMicrophoneData } from "../../../services/data/microphone";

const TITLE = "Microphone devices";

const SelectMicrophoneDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  const [data, setData] = useState([]); // The microphone devices ids and labels.

  // Get the microphone ids and labels.
  useEffect(() => {
    const fetchData = async () => {
      loadingDevices.add(1);
      const data = await getBasicMicrophoneData();
      setData(data);
      onChange(data);
      loadingDevices.done();
    };
    fetchData();
  }, []);

  return (
    <SelectDevices
      selectedDevices={selectedDevices}
      onChange={onChange}
      title={TITLE}
      data={data}
      disabled={disabled}
    />
  );
};

export default SelectMicrophoneDevices;
